export default "__VITE_PUBLIC_ASSET__8022bcfd__"